import { render, staticRenderFns } from "./ScoredActivities.vue?vue&type=template&id=3223bfe0&scoped=true"
import script from "./ScoredActivities.vue?vue&type=script&lang=js"
export * from "./ScoredActivities.vue?vue&type=script&lang=js"
import style0 from "./ScoredActivities.vue?vue&type=style&index=0&id=3223bfe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3223bfe0",
  null
  
)

export default component.exports